/**
 * Local vehicle images — put files in /public/vehicles/
 * Prefer WebP (resized ~600px). PNG kept as fallback for older browsers.
 *
 * Firestore still supplies names/prices; these replace broken Firebase Storage URLs.
 */
export const LOCAL_VEHICLE_IMAGES = {
  "Budget SUV": "/vehicles/budget-suv.webp",
  "Budget Car": "/vehicles/budget-car.webp",
  "1 Tonne Ute": "/vehicles/1-tonne-ute.webp",
  "European Car": "/vehicles/european-car.webp",
  "1 TONNE Van": "/vehicles/1-tonne-van.webp",
  "Compact Car": "/vehicles/compact-car.webp",
  "Dual Cab Ute": "/vehicles/dual-cab-ute.webp",
  "7 SEATER": "/vehicles/7-seater.webp",
  "Hilux Tradie Spec": "/vehicles/hilux-tradie-spec.webp",
  "7 Seater Hybrid": "/vehicles/7-seater-hybrid.webp",
  "Medium Size Car": "/vehicles/medium-size-car.webp",
  "Economy 1 Tonne Van": "/vehicles/economy-1-tonne-van.webp",
  "LARGE SUV": "/vehicles/large-suv.webp",
  "1.5 TONNE VAN": "/vehicles/1-5-tonne-van.webp",
};

/** Fallback when a vehicle has no local image file yet */
export const VEHICLE_IMAGE_PLACEHOLDER = "/vehicles/placeholder.svg";

export function getLocalVehicleImage(vehicleName) {
  if (!vehicleName) return VEHICLE_IMAGE_PLACEHOLDER;
  const key = String(vehicleName).trim();
  return LOCAL_VEHICLE_IMAGES[key] || VEHICLE_IMAGE_PLACEHOLDER;
}

/** PNG fallback path for a WebP vehicle image */
export function getVehicleImagePngFallback(imageUrl) {
  if (!imageUrl || !imageUrl.endsWith(".webp")) return null;
  return imageUrl.replace(/\.webp$/i, ".png");
}

/**
 * Full offline fleet (used when Firestore fails / while loading).
 * Keep in sync with LOCAL_VEHICLE_IMAGES keys.
 */
export const LOCAL_VEHICLES = [
  {
    id: "local-budget-suv",
    vehicleName: "Budget SUV",
    perDayPrice: "240",
    imageUrl: LOCAL_VEHICLE_IMAGES["Budget SUV"],
  },
  {
    id: "local-budget-car",
    vehicleName: "Budget Car",
    perDayPrice: "195",
    imageUrl: LOCAL_VEHICLE_IMAGES["Budget Car"],
  },
  {
    id: "local-1-tonne-ute",
    vehicleName: "1 Tonne Ute",
    perDayPrice: "275",
    imageUrl: LOCAL_VEHICLE_IMAGES["1 Tonne Ute"],
  },
  {
    id: "local-european-car",
    vehicleName: "European Car",
    perDayPrice: "350",
    imageUrl: LOCAL_VEHICLE_IMAGES["European Car"],
  },
  {
    id: "local-1-tonne-van",
    vehicleName: "1 TONNE Van",
    perDayPrice: "275",
    imageUrl: LOCAL_VEHICLE_IMAGES["1 TONNE Van"],
  },
  {
    id: "local-compact-car",
    vehicleName: "Compact Car",
    perDayPrice: "210",
    imageUrl: LOCAL_VEHICLE_IMAGES["Compact Car"],
  },
  {
    id: "local-dual-cab-ute",
    vehicleName: "Dual Cab Ute",
    perDayPrice: "350",
    imageUrl: LOCAL_VEHICLE_IMAGES["Dual Cab Ute"],
  },
  {
    id: "local-7-seater",
    vehicleName: "7 SEATER",
    perDayPrice: "295",
    imageUrl: LOCAL_VEHICLE_IMAGES["7 SEATER"],
  },
  {
    id: "local-hilux-tradie-spec",
    vehicleName: "Hilux Tradie Spec",
    perDayPrice: "300",
    imageUrl: LOCAL_VEHICLE_IMAGES["Hilux Tradie Spec"],
  },
  {
    id: "local-7-seater-hybrid",
    vehicleName: "7 Seater Hybrid",
    perDayPrice: "385",
    imageUrl: LOCAL_VEHICLE_IMAGES["7 Seater Hybrid"],
  },
  {
    id: "local-medium-size-car",
    vehicleName: "Medium Size Car",
    perDayPrice: "220",
    imageUrl: LOCAL_VEHICLE_IMAGES["Medium Size Car"],
  },
  {
    id: "local-economy-1-tonne-van",
    vehicleName: "Economy 1 Tonne Van",
    perDayPrice: "220",
    imageUrl: LOCAL_VEHICLE_IMAGES["Economy 1 Tonne Van"],
  },
  {
    id: "local-large-suv",
    vehicleName: "LARGE SUV",
    perDayPrice: "385",
    imageUrl: LOCAL_VEHICLE_IMAGES["LARGE SUV"],
  },
  {
    id: "local-1-5-tonne-van",
    vehicleName: "1.5 TONNE VAN",
    perDayPrice: "275",
    imageUrl: LOCAL_VEHICLE_IMAGES["1.5 TONNE VAN"],
  },
];
